import React, { forwardRef } from 'react';
import InputTemplate from '../TemplateNumberFormatInput';

const CstInput = forwardRef((props, ref) => (
  <InputTemplate {...props} formato="###" ref={ref} />
));

export default CstInput;
